import { CellProps } from "react-table";
import Status from "src/components/status/Status";
import TextCell from "src/components/tables/cells/TextCell";
import { getFormattedDate, getFormattedTime } from "src/helpers/helpers";
import { LEAD_STATUS, LEAD_STATUS_CELL } from "src/utils/constants";
import ActionsCell from "./ActionsCell";
import { EnquiryType } from "./enquiry-types";

const useEnquiryTableColumns = ({
  onDelete,
}: {
  onDelete: (id: number) => void;
}) => {
  return [
    {
      Header: "Client name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: TextCell,
    },

    {
      Header: "Number",
      accessor: "phone",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Query",
      accessor: "query",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Follow-up date and time",
      accessor: "followUpDate",
      className: "min-w-[150px]",
      Cell: ({
        row: {
          original: { followUpDate, followUpTime },
        },
      }: CellProps<EnquiryType>) => (
        <>
          {followUpDate && (
            <TextCell
              value={getFormattedDate(followUpDate)}
              className="py-0 text-black-raisin leading-normal"
            />
          )}
          {followUpTime && (
            <TextCell
              value={getFormattedTime(followUpTime)}
              className="py-0 text-black-raisin !text-14px leading-6"
            />
          )}
        </>
      ),
    },
    {
      Header: "Lead type",
      accessor: "leadType",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Status",
      accessor: "leadStatus",
      className: "min-w-[150px]",
      Cell: ({ value }: CellProps<EnquiryType>) => {
        const status = LEAD_STATUS_CELL[value as LEAD_STATUS];
        return <Status {...status} />;
      },
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<EnquiryType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useEnquiryTableColumns;
